export function GoogleIcon() {
  return (
    <svg width='18' height='18' viewBox='0 0 18 18' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844a4.14 4.14 0 0 1-1.796 2.716v2.259h2.908c1.702-1.567 2.684-3.875 2.684-6.615z'
        fill='#4285F4'
      />
      <path
        d='M9 18c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A8.997 8.997 0 0 0 9 18z'
        fill='#34A853'
      />
      <path
        d='M3.964 10.71A5.41 5.41 0 0 1 3.682 9c0-.593.102-1.17.282-1.71V4.958H.957A8.996 8.996 0 0 0 0 9c0 1.452.348 2.827.957 4.042l3.007-2.332z'
        fill='#FBBC05'
      />
      <path
        d='M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A8.997 8.997 0 0 0 .957 4.958L3.964 7.29C4.672 5.163 6.656 3.58 9 3.58z'
        fill='#EA4335'
      />
    </svg>
  );
}

export function LinkedInIcon() {
  return (
    <svg width='18' height='18' viewBox='0 0 18 18' xmlns='http://www.w3.org/2000/svg'>
      <rect width='18' height='18' rx='2' fill='#0A66C2' />
      <path
        d='M5.37 7.2H3.24v6.6h2.13V7.2zM4.305 6.27a1.23 1.23 0 1 0 0-2.46 1.23 1.23 0 0 0 0 2.46zM14.76 13.8h-2.13v-3.21c0-.767-.015-1.755-1.065-1.755-1.068 0-1.233.836-1.233 1.698V13.8H8.19V7.2h2.046v.9h.03c.285-.54.975-1.11 2.01-1.11 2.148 0 2.544 1.416 2.544 3.255V13.8h-.06z'
        fill='#fff'
      />
    </svg>
  );
}
